import { CalendarClock } from 'lucide-react'
import type { SeriesUpcomingEpisode } from '../../types/series'

interface UpcomingEpisodesSectionProps {
  episodes: SeriesUpcomingEpisode[]
}

function formatProjectedPublishAt(dateStr: string): string {
  return new Date(dateStr).toLocaleString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function UpcomingEpisodesSection({ episodes }: UpcomingEpisodesSectionProps) {
  if (episodes.length === 0) {
    return null
  }

  return (
    <section className="space-y-4">
      <div className="flex items-center gap-2">
        <CalendarClock className="h-5 w-5 text-brand-600" />
        <h2 className="text-lg font-semibold text-foreground">Upcoming episodes</h2>
      </div>

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
        {episodes.map((episode, index) => (
          <article key={`${episode.projectedPublishAt}-${index}`} className="rounded-2xl border border-black/6 bg-white p-5 shadow-sm">
            <p className="text-xs font-medium uppercase tracking-[0.12em] text-foreground/40">
              {formatProjectedPublishAt(episode.projectedPublishAt)}
            </p>
            <h3 className="mt-3 text-base font-semibold text-foreground">
              {episode.title?.trim() ? episode.title : 'Topic preview'}
            </h3>
            <p className="mt-2 line-clamp-4 text-sm leading-6 text-foreground/60">
              {episode.topicPreview}
            </p>

            {episode.description && episode.description !== episode.topicPreview && (
              <p className="mt-3 line-clamp-3 text-sm text-foreground/45">{episode.description}</p>
            )}

            {episode.keyTopics.length > 0 && (
              <div className="mt-4 flex flex-wrap gap-2">
                {episode.keyTopics.map((topic) => (
                  <span key={topic} className="rounded-full bg-brand-50 px-2.5 py-1 text-xs font-medium text-brand-700">
                    {topic}
                  </span>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  )
}